import { Spinner } from "react-bootstrap"
import "../styles/centered-spinner.css";

export const CenteredSpinner: React.FC = () => {
  return (
    <div className="centered-spinner">
      <Spinner animation="border" />
    </div>
  )
}
